let localEnvironment = (window as any).scaffoldEnvironment;
if (!localEnvironment) {
  console.warn('No environment configuration found. Using default development environment.');
  localEnvironment = {
    production: false,
    suppressLog: false,
    name: 'K16 Test',
    domain: 'test-domain',
    cognitoUserPoolId: 'test-user-pool-id',
    cognitoClientId: 'test-client-id',
    env: 'test',
    dd_applicationId: 'test-application-id',
    dd_clientToken: 'test-client-token',
    apiRoot: '/api',
    socketUrl: 'wss://test-socket.k16.io',
    secureCookie: false,
    cookieDomain: 'localhost',
    multiInstance: false,
    isOPM: false,
    opmReference: null,
  };
}
export const environment = localEnvironment;